import { useEffect } from "react"
import { useNavigate } from "react-router"
import { RO_MANAGE_AMBASSADOR } from "../../../constants/Routes"

export default function Redirect({to}: {to: string}) {

    const navigate = useNavigate()

    useEffect(() => {
navigate(RO_MANAGE_AMBASSADOR)
    }, [])
    return null
}